import RouteEnum from "constants/RouteEnum";
import IStore from "models/IStore";
import { Dispatch, Middleware, MiddlewareAPI } from "redux";
import UtenteAction from "stores/utente/UtenteAction";
import NavigationUtility from "utilities/NavigationUtility";
import IAction from "../models/IAction";

const userLoggedMiddleware = (): Middleware => (store: MiddlewareAPI<Dispatch, IStore>) => (next: Dispatch) => (
    action: IAction<any>
): void => {
    next(action);

    if (action.type === "@@router/LOCATION_CHANGE") {
        let pathname = action.payload?.location?.pathname ?? "";
        let required = true;
        if (pathname && Object.values(RouteEnum).includes(pathname) === false) {
            // custom content pages
            required = false;
        }
        switch (pathname) {
            // login not required routes
            case RouteEnum.ACCESSO:
                required = false;
                break;
        }

        // get token from sessionStorage and set isLogged and isLoginRequired
        next(UtenteAction.utenteLoginRequiredSet(required)); //TODO: required

        // redirect if not logged and login required
        if (
            (pathname === "/" || pathname === RouteEnum.HOME) &&
            required === true &&
            store.getState().utente.profilo.isLogged === false
        ) {
            NavigationUtility.redirectToPage(RouteEnum.ACCESSO);
        }
    }
};

export default userLoggedMiddleware;
